import styled from "styled-components";
import Colors from "assets/Colors";

const Container = styled.div`
  max-width: 180px;
  max-height: 195px;
  border-radius: 6px;
  align-items: center;
  padding: 5px 13px;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);
`;

const ContainerOption = styled.div`
  text-align: end;
`;

const Div = styled.div``;

const ContainerImage = styled.div`
  background-color: ${Colors.primary};
  height: 80px;
  width: 80px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const borderImage = styled.div`
  background-color: #fff;
  height: 74px;
  width: 74px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const containerInitials = styled.div`
  background-color: ${Colors.primary};
  height: 70px;
  width: 70px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
`;

const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 5px;
  margin-top: 10px;
  margin-bottom: 31px;
`;

const ContainerName = styled.h1`
  font-size: 15px;
  font-weight: 500;
`;

const Info = styled.div`
  font-size: 12px;
  font-weight: 300;
`;

export default {
  Container,
  ContainerOption,
  ContainerImage,
  Div,
  borderImage,
  containerInitials,
  ContainerInfo,
  ContainerName,
  Info,
};
